import { useEffect, useState, useContext } from "react";
import PatrolsService from "../../services/patrols.service";
import styles from "./PatrolmeterEdit.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../contexts/auth.context";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";

function PatrolsPage() {
  const [patrols, setPatrols] = useState([]);
  useContext(AuthContext);

  useEffect(() => {
    const fetchPatrols = async () => {
      const response = await PatrolsService.getPatrols();

      setPatrols(response.data);
    };

    fetchPatrols();
  }, []);

  const _updatePatrols = async (ev, id, plus) => {
    try {
      const actualScore = patrols.find((s) => s._id === id).score;
      const newScore = plus ? actualScore + 1 : actualScore - 1;
      const response = await PatrolsService.update(id, newScore);
      const _id = response?.data?._id;
      const PatrolsUpdated = patrols.map((s) => {
        if (s._id === _id) {
          s.score = newScore;
        }
        return s;
      });
      setPatrols(PatrolsUpdated);
    } catch {}
  };

  return (
    <>
      <div className={styles["list-container"]}>
        <ScreenHeader title="Control Patrullometro" />

        <div className={styles["elementos-lista"]}>
          {patrols.map((s) => (
            <div className={styles["patrols-elemento"]} key={s._id}>
              <div className={styles["patrols-name"]}>{s.name}</div>
              <div className={styles["patrols-action"]}>
                <button
                  className={styles["minus-button"]}
                  onClick={(ev) => _updatePatrols(ev, s._id, false)}
                >
                  <FontAwesomeIcon icon={faMinus} />
                </button>

                <div className={styles.patrolsScore}>{s.score}</div>

                <button
                  className={styles["add-button"]}
                  onClick={(ev) => _updatePatrols(ev, s._id, true)}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default PatrolsPage;
